import Cookies from 'js-cookie'

const LoginKey = 'hasLogin'

export function getToken() {
  return Cookies.get(LoginKey);
}

export function setToken() {
  return Cookies.set(LoginKey, "1")
}

export function removeToken() {
  return Cookies.remove(LoginKey)
  return Cookies.remove("token")
  return Cookies.remove('uid')
}

export function getCookie(key) {
  return Cookies.get(key);
}

export function setCookie(key,value) {
  return Cookies.set(key, value)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js